import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '../../../../../styles';
import Toggle from 'material-ui/Toggle';
import styles from './styles';

import { defaultMapStateToProps, defaultMapDispatchToProps } from '../redux';

function mapStateToProps(state, ownProps) {
    let value = state.crud.entityCrud.get(ownProps.field.id.toLowerCase());
    return {
        ...defaultMapStateToProps(state, ownProps),
        value: value && value.value !== undefined ? value.value : value,
    };
}

const propTypes = {
    styles: PropTypes.string.isRequired,
    field: PropTypes.object.isRequired,
    error: PropTypes.string,
    mandatory: PropTypes.bool,
    description: PropTypes.string.isRequired,
    readOnly: PropTypes.bool,
    hidden: PropTypes.bool,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onRemove: PropTypes.func,
};

@connect(mapStateToProps, defaultMapDispatchToProps)
@withStyles(styles)
class CrudBoolField extends Component {
    onToggle = (_, value) => {
        let { onChange, onRemove, field } = this.props;
        if (value) {
            onChange && onChange(field.id, true);
        } else {
            onRemove && onRemove(field.id);
        }
    };

    render() {
        let { styles, field, hidden, readOnly, mandatory, description, error, value } = this.props;
        return !hidden ? (
            <div
                className="toggle-crud-field-container"
                style={{ ...styles.fieldContainer, ...{ height: 50, marginTop: 13 } }}
            >
                <span style={styles.title}>
                    {description} {mandatory ? '*' : ''}
                </span>
                <span className="toggle-crud-field">
                    <Toggle
                        errorText={error}
                        disabled={readOnly}
                        style={{ maxWidth: 250, display: 'inline-block' }}
                        defaultToggled={value}
                        onToggle={this.onToggle}
                    />
                </span>
            </div>
        ) : null;
    }
}

CrudBoolField.propTypes = propTypes;

export default CrudBoolField;
